import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Rating } from 'react-simple-star-rating'

export default function  Addrating(data_user_id) {
    
    const [rating, setRating] = useState(0);
        const handleRating = (rate) => {
            setRating(rate);
        };

        const action = `${BASE.url}`+'rate-seller';
        return (
            <div className='App'>
                <div className="content">
                <Rating 
                    onClick={handleRating}
                    ratingValue	= {rating}
                    transition
                    size={45}
                    stars={5}
                >
      
                    {/* Set `fill`, `width`, `height` */}
                    <svg fill='currentColor' width='35' height='35' viewBox='0 0 24 24'>
                        <path d='M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' />
                    </svg>
                    
                    </Rating>
                    <form action={ action } method="POST">
                        <div className="form-group">
                            <input className="hidden_rateInput" type="number" name="rate" value={rating} placeholder=""/>
                            <textarea rows="5" name="comment" placeholder=""></textarea>
                            <br/>
                            <input value={data_user_id.data_user_id} name="sellerId" type="hidden"/>
                            <input  type="submit" value={formMessages.btn_submit_rate} className="submit_rate btn primary-1-btn"/>
                        </div> 
                    </form>
                </div>
            </div>
        );
    
  ReactDOM.render(<CustomForm {...data} />, customFormDom);
}